import { render, staticRenderFns } from "./Statistic.vue?vue&type=template&id=1ceac4b8"
import script from "./Statistic.vue?vue&type=script&lang=ts"
export * from "./Statistic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports